module.exports = __webpack_public_path__ + "img/zpzw.caccbf10.png";